var angular = require('angular');
var _module = require('../../components/module');

_module.provider('$activityFeed', function activityFeedProvider() {
    /*
    url
    The base url for the API to hit. defaults to ''
    Example - https://www.listreports.com
    */
    var url = '';

    this.setBaseUrl = function setUrl(value) {
        url = value;
    };

    /*
    Return the factory
    */
    this.$get = [
        '$log',
        '$http',
        '$q',

        function activityFeedFactory($log, $http, $q) {
            return {
                /*
                Adds activity to a users a feed

                @function add
                @param {Object} activityData
                @param {String} activityData.userId
                @param {String} activityData.type - realtor or lead
                @param {String} activityData.name - the event name (see https://docs.google.com/spreadsheets/d/19YHTokg95YZoXvFVT8Ecs-IJ6ut_FXZ0JFsyXRLL3po/edit#gid=0 for names)
                @param {String} [activityData.avatar] - image url or none or initials or ""
                @param {Object} [activityData.meta]
                @returns {Promise}
                */
                add: function add(activityData) {
                    return $http.post(url + '/v1/activities', activityData)
                        .then(function onResponse(response) {
                            $log.debug('Activity Added Successfully', response);

                            return response.data;
                        })
                        .catch(function onError(err) {
                            $log.error('$activityFeed - add - Error', err);

                            return $q.reject(err.data);
                        });
                },

                /*
                Updates the last seen activity

                @function updateLastSeen
                @param {Object} user - The $user object
                */
                updateLastSeen: function updateLastSeen($user) {
                    var data = {
                        avatar: 'initials',
                        type: 'lead',
                        name: 'benoit_user_last_seen_on_site',
                        userId: $user.affiliateId,
                        meta: {
                            benoitUserId: $user.id,
                            name: $user.full_name,
                            first_name: $user.first_name,
                            last_name: $user.last_name,
                            timestamp: new Date().getTime()
                        }
                    };

                    return $http.post(url + '/v1/activities/lastseen/' + $user.id, data)
                        .then(function onResponse(response) {
                            $log.debug('Updated Last Seen ', response);

                            return response.data;
                        })
                        .catch(function onError(err) {
                            $log.error('$activityFeed - updateLastSeen - Error', err);

                            return $q.reject(err.data);
                        });
                }
            };
        }
    ];
});
